import { render, staticRenderFns } from "./px-grid.vue?vue&type=template&id=799d1a76&"
import script from "./px-grid.vue?vue&type=script&lang=ts&"
export * from "./px-grid.vue?vue&type=script&lang=ts&"
import style0 from "./px-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports